import { useEffect, useRef, useState } from "react";
import { getRequestWithToken } from "../../../utils/ApiRequests";

export const TREE_ROLE_SEARCH_DELAY = 350;
export const canSearchTreeRoles = (value) => value.trim().length >= 2;

const useHierarchyRoleSearch = (query, retryToken = 0) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const requestSequence = useRef(0);

  useEffect(() => {
    const searchValue = query.trim();
    const requestId = requestSequence.current + 1;
    requestSequence.current = requestId;

    if (!canSearchTreeRoles(searchValue)) {
      setResults([]);
      setLoading(false);
      setError("");
      return undefined;
    }

    setResults([]);
    setLoading(true);
    setError("");
    const timer = setTimeout(async () => {
      try {
        const response = await getRequestWithToken(
          `../v3/admin/nco-hierarchy/search?query=${encodeURIComponent(searchValue)}&limit=50`
        );
        if (requestId === requestSequence.current) {
          setResults(response.data?.data?.results || []);
        }
      } catch (requestError) {
        if (requestId === requestSequence.current) {
          setResults([]);
          setError(requestError?.response?.data?.msg || "Unable to search roles. Retry or change the query.");
        }
      } finally {
        if (requestId === requestSequence.current) setLoading(false);
      }
    }, TREE_ROLE_SEARCH_DELAY);

    return () => clearTimeout(timer);
  }, [query, retryToken]);

  return { results, loading, error };
};

export default useHierarchyRoleSearch;
